import vuerouter from "vue-router";
import FormularioRequisicionPago from "./views/FormularioRequisicionPago.vue";
import FormularioDatosGenerales from "./views/FormularioDatosGenerales.vue";
import FormularioCentroCosto from "./views/FormularioCentroCosto.vue";
import HistoricoRequisionesPago from "./views/HistoricoRequisicionPago.vue";
import RequisicionesPagoHistorico from "./views/RequisicionPagoHistorico.vue";
import VistaDetalle from "./views/VistaDetalle.vue";
import Dashboard from "./views/Dashboard.vue";
import HistoricoCarrusel from "./views/HistoricoRequsicionesCarrusel.vue";
import PlantillasVista from "./views/PlantillasVista.vue";
import CatalogoCodigosPresupuesto from "./views/CatalogoCodigosPresupuesto.vue";

const ROL_PLANEACION_FINANCIERA = "Planeación Financiera";

/**
 * Valida en sessionStorage (listaRoles) que el usuario tenga el rol de Planeación Financiera
 */
function EsPlaneacionFinanciera(): boolean {
  try {
    const roles: string[] = JSON.parse(window.sessionStorage.getItem("listaRoles") || "[]").flat();
    return roles.includes(ROL_PLANEACION_FINANCIERA);
  } catch (error) {
    return false;
  }
}

const rutas: vuerouter.RouteRecordRaw[] = [
  {
    component: HistoricoRequisionesPago,
    path: ""
  },
  {
    component: Dashboard,
    path: "/dashboard",
    name: "srp-requisicion-pago-dashboard"
  },
  {
    component: HistoricoRequisionesPago,
    path: "/historico-requisicion-pago/:rolUsuario",
    name: "srp-requisicion-pago-historico"
  },
  {
    component: FormularioRequisicionPago,
    path: "/formulario-requisicion-pago",
    name: "crear-requisicion"
  },
  {
    component: FormularioRequisicionPago,
    path: "/formulario-requisicion-pago",
    name: "crear-requisicion-plantilla"
  },
  {
    component: FormularioRequisicionPago,
    path: "/editar-requisicion-pago/:requisicionPagoId"
  },
  {
    component: FormularioCentroCosto,
    path: "/formulario-centro-costo"
  },
  {
    component: VistaDetalle,
    path: "/vista-detalle-solicitud/:rolUsuario"
  },
  {
    component: RequisicionesPagoHistorico,
    path: "/requisicion-pago-historico/:rolUsuario",
    name: "srp-requisicion-pago-requisiciones"
  },
  {
    component: HistoricoCarrusel,
    path: "/historico-requisiones-carrusel/:rolUsuario",
    name: "srp-requisicion-pago-requisiciones-carrusel"
  },
  {
    component: PlantillasVista,
    path: "/plantillas/",
    name: "srp-requisicion-pago-plantillas"
  },
  {
    component: CatalogoCodigosPresupuesto,
    path: "/catalogo-codigos-presupuesto",
    name: "srp-requisicion-pago-catalogo-codigos",
    beforeEnter: () => (EsPlaneacionFinanciera() ? true : { name: "srp-requisicion-pago-dashboard" })
  }
];

export default rutas;
